import container from "./container.vue";
import halaman1 from "./views/halaman1.vue";
import halaman2 from "./views/halaman2.vue";

const authFalse = { requireAuth: false };
const authTrue = { requireAuth: true };
const router = [
  {
    path: "/playground",
    component: container,
    children: [
      {
        path: "",
        component: halaman1,
        name: "halaman1",
        meta: {
          ...authTrue,
        },
      },
      {
        path: "halaman2",
        component: halaman2,
        name: "halaman2",
        meta: {
          ...authFalse,
        },
      },
    ],
  },
];

export default router;
